module.exports = __webpack_public_path__ + "static/media/seguros-mundial-parking-selected.6e25d228.svg";